export default __webpack_public_path__ + "static/index_reason_camera-18df43d2e6252a9ee692b5b57a1e58d6.png";